// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/CollectionBar/collectionBar.css
// module id = 1722
// module chunks = 0